/**
 * What the code screen knows once a code is asked: where it went, and whether
 * the email carries « Me connecter » — the backend says so (every email does,
 * a number never does). An answer without the flag (older backend) never
 * points to a link that may not exist.
 */
export const codeSentTo = (identifier, data) => ({
    identifier,
    channel: data?.channel,
    emailHasLink: data?.channel === "email" && data?.magic_link === true,
})
